import React, { useState } from "react";

import { useNavigate, Link } from "react-router-dom";

import ConfirmModal from "../../components/ConfirmModal";

import { toast } from "react-toastify";

import ApiCustom from "../../utils/ApiCustom";

import LinkButtonTitle from "../LinkButtonTitle";

import {
  DesktopAdvertisementReplaceSlot,
  hasAdvertisementByPosition,
} from "./AdvertisementDisplay";

export default function MemberProducts({
  data,
  adCategories = [],
  adMedias = [],
  compact = false,
  hideRightAd = false,
}) {
  const navigate = useNavigate();

  const userId = localStorage.getItem("userId");

  const isApproved = localStorage.getItem("isApproved") === "true";

  const [isOpenContactModal, setIsOpenContactModal] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState(null);

  const hasLeftAd = hasAdvertisementByPosition({
    positionKey: "desktop_replace_products_left",
    categories: adCategories,
    medias: adMedias,
  });

  const hasRightAd =
    !hideRightAd &&
    hasAdvertisementByPosition({
      positionKey: "desktop_replace_products_right",
      categories: adCategories,
      medias: adMedias,
    });

  const totalAdCount = Number(hasLeftAd) + Number(hasRightAd);

  const products = (data || []).slice(0, Math.max(16 - totalAdCount, 0));

  if (!products.length && !hasLeftAd && !hasRightAd) return null;

  const handleOrder = (product) => {
    if (!userId || !isApproved) {
      setSelectedProduct(product);

      setIsOpenContactModal(true);

      return;
    }

    const cart = JSON.parse(localStorage.getItem("cart")) || [];

    const newProduct = {
      id: product.id,
      company: product.companyId,
      image: Array.isArray(product.urlImage)
        ? product.urlImage[0]
        : product.urlImage,
      name: product.name,
      price: product.price,
      quantity: 1,
      gift: product.gift,
      condition: Number(product.giftCondition),
    };

    // Nếu đã có sản phẩm cùng ID thì tăng số lượng
    let isProductExist = false;

    let updatedCart = cart.map((item) => {
      if (item.id === newProduct.id) {
        isProductExist = true;

        return { ...item, quantity: item.quantity + 1 };
      }

      return item;
    });

    if (!isProductExist) updatedCart.push(newProduct);

    localStorage.setItem("cart", JSON.stringify(updatedCart));

    navigate("/gio-hang");
  };

  // Hàm gửi liên hệ
  const handleContact = (formData) => {
    if (!selectedProduct) return;

    const postData = {
      ...formData,
      companyId: selectedProduct.companyId,
      productId: selectedProduct.id,
    };

    ApiCustom.post("/contact-create", postData, {
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        if (res.data.data?.status === 200) {
          toast.success("Liên hệ đặt hàng thành công");

          setIsOpenContactModal(false);
        }
      })
      .catch((err) => {
        console.log(err);

        toast.error("Gửi liên hệ thất bại");
      });
  };

  const renderProductCard = (product, idx) => (
    <div
      key={product.id || idx}
      className="flex flex-col bg-white rounded-xl shadow-md hover:shadow-lg cursor-pointer transition p-0 h-full"
    >
      {/* Hình ảnh trên */}
      <div className="w-full aspect-[5/4] rounded-t-xl overflow-hidden bg-gray-50">
        <img
          src={
            Array.isArray(product.urlImage)
              ? product.urlImage[0]
              : product.urlImage
          }
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-300"
          loading="lazy"
        />
      </div>

      <div className="px-4 pt-3 pb-4 flex-1 flex flex-col">
        {/* Tên */}
        <h3 className="font-semibold text-lg mb-2 line-clamp-2 text-justify">
          {product.name}
        </h3>

        {/* Mô tả - render HTML từ texteditor, clamp 3 dòng, min-height để nút luôn ở cuối */}
        <div
          className="text-gray-600 text-sm mb-2 text-justify line-clamp-3"
          style={{
            minHeight: 60,
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
          dangerouslySetInnerHTML={{
            __html: product.description || "Không có mô tả.",
          }}
        />

        <div className="flex gap-2 mt-auto">
          <button
            className="flex-1 border border-blue-600 text-blue-600 rounded-lg px-3 py-2 hover:bg-blue-50 transition"
            onClick={() => navigate("/san-pham/" + product.slug)}
          >
            Chi tiết
          </button>

          <button
            className="flex-1 bg-blue-600 text-white rounded-lg px-3 py-2 hover:bg-blue-700 transition"
            onClick={() => handleOrder(product)}
          >
            {!userId || !isApproved ? "Liên hệ" : "Đặt hàng"}
          </button>
        </div>
      </div>
    </div>
  );

  const renderProductContent = () => {
    const result = [];

    if (hasLeftAd) {
      result.push(
        <DesktopAdvertisementReplaceSlot
          key="desktop_replace_products_left"
          positionKey="desktop_replace_products_left"
          categories={adCategories}
          medias={adMedias}
        />,
      );
    }

    products.forEach((product, idx) => {
      result.push(renderProductCard(product, idx));
    });

    if (hasRightAd) {
      result.push(
        <DesktopAdvertisementReplaceSlot
          key="desktop_replace_products_right"
          positionKey="desktop_replace_products_right"
          categories={adCategories}
          medias={adMedias}
        />,
      );
    }

    return result;
  };

  return (
    <section className={compact ? "mb-12" : "mt-16"}>
      <LinkButtonTitle title={"Sản phẩm hội viên"}>
        <Link
          to={`/danh-sach-san-pham`}
          className=" font-semibold text-blue-800 hover:text-blue-600 transition duration-200"
        >
          Xem tất cả
        </Link>
      </LinkButtonTitle>

      <div
        className={
          compact
            ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 auto-rows-fr items-stretch gap-6"
            : "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 auto-rows-fr items-stretch gap-6"
        }
      >
        {renderProductContent()}
      </div>

      <ConfirmModal
        isOpen={isOpenContactModal}
        onClose={() => setIsOpenContactModal(false)}
        message="Vui lòng nhập thông tin liên hệ để đặt hàng"
        isForm={true}
        onSubmit={handleContact}
        title="Liên hệ"
      />
    </section>
  );
}